const EVOLUTION_API_URL = import.meta.env.VITE_EVOLUTION_API_URL;
const EVOLUTION_API_KEY = import.meta.env.VITE_EVOLUTION_API_KEY;

const headers = {
    'Content-Type': 'application/json',
    'apikey': EVOLUTION_API_KEY
};

import { typebotService } from './typebotService';

export const evolutionApi = {
    // Criar uma nova instância
    createInstance: async (instanceName, phoneNumber) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/create`, {
                method: 'POST',
                headers,
                body: JSON.stringify({
                    instanceName,
                    number: phoneNumber,
                    qrcode: true,
                    integration: "WHATSAPP-BAILEYS"
                })
            });

            if (!response.ok) {
                throw new Error('Erro ao criar instância');
            }

            const data = await response.json();
            
            return {
                ...data,
                instanceName: data.instance?.instanceName || instanceName,
                key: data.hash,
                status: 'created'
            };
        } catch (error) {
            console.error('Erro ao criar instância:', error);
            throw error;
        }
    },

    // Obter QR Code para conexão
    getQrCodeForConnection: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/connect/${instanceName}`, {
                method: 'GET',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao obter QR Code');
            }

            return await response.json();
        } catch (error) {
            console.error('Erro ao obter QR Code:', error);
            throw error;
        }
    },

    // Obter QR Code
    getQrCode: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/connect/${instanceName}`, {
                method: 'GET',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao obter QR Code');
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Erro ao obter QR Code:', error);
            throw error;
        }
    },

    // Verificar status da conexão
    getConnectionState: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/connectionState/${instanceName}`, {
                method: 'GET',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao verificar status da conexão');
            }

            const data = await response.json();
            // Mapear os estados da Evolution API para nossos estados
            const stateMap = {
                'open': 'connected',
                'connecting': 'connecting',
                'close': 'disconnected'
            };

            return {
                status: stateMap[data.instance?.state] || 'disconnected',
                instanceName: data.instance?.instanceName || instanceName
            };
        } catch (error) {
            console.error('Erro ao verificar status da conexão:', error);
            throw error;
        }
    },

    // Desconectar instância (logout)
    disconnectInstance: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/logout/${instanceName}`, {
                method: 'DELETE',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao desconectar instância');
            }

            return {
                status: 'disconnected',
                instanceName
            };
        } catch (error) {
            console.error('Erro ao desconectar instância:', error);
            throw error;
        }
    },

    // Deletar instância
    deleteInstance: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/delete/${instanceName}`, {
                method: 'DELETE',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao deletar instância');
            }

            return {
                status: 'deleted',
                instanceName
            };
        } catch (error) {
            console.error('Erro ao deletar instância:', error);
            throw error;
        }
    },

    // Reiniciar instância
    restartInstance: async (instanceName) => {
        try {
            const response = await fetch(`${EVOLUTION_API_URL}/instance/restart/${instanceName}`, {
                method: 'POST',
                headers
            });

            if (!response.ok) {
                throw new Error('Erro ao reiniciar instância');
            }

            return {
                status: 'restarted',
                instanceName
            };
        } catch (error) {
            console.error('Erro ao reiniciar instância:', error);
            throw error;
        }
    }
};
